import { createApi } from "@reduxjs/toolkit/query/react";
import { TagType, USER } from "../../configs";
import { UserAddress, RegisterResponse } from "../../types/user.interfaces";
import { createBaseQuery } from "../helpers/baseQueryHelper";

export const userApi = createApi({
  reducerPath: USER.reducerPath,
  baseQuery: createBaseQuery(USER.baseUrl),
  tagTypes: USER.tagTypes,
  endpoints: (builder) => ({
    getUserInfo: builder.query<RegisterResponse, void>({
      query: () => "/info",
      providesTags: [TagType.UserProfile],
    }),
    getAddresses: builder.query<UserAddress[], void>({
      query: () => "/addresses",
      providesTags: [TagType.UserAddress],
    }),
    addAddress: builder.mutation<UserAddress[], UserAddress>({
      query: (address) => ({
        url: "/addresses",
        method: "POST",
        body: address,
      }),
      invalidatesTags: [TagType.UserAddress],
    }),
    updateAddress: builder.mutation<
      UserAddress[],
      { addressId: string; address: UserAddress }
    >({
      query: ({ addressId, address }) => ({
        url: `/addresses/${addressId}`,
        method: "PUT",
        body: address,
      }),
      invalidatesTags: [TagType.UserAddress],
    }),
    deleteAddress: builder.mutation<UserAddress[], string>({
      query: (addressId) => ({
        url: `/addresses/${addressId}`,
        method: "DELETE",
      }),
      invalidatesTags: [TagType.UserAddress],
    }),
    setDefaultAddress: builder.mutation<UserAddress[], string>({
      query: (addressId) => ({
        url: `/addresses/${addressId}/default`,
        method: "PUT",
      }),
      invalidatesTags: [TagType.UserAddress],
    }),
    updateProfile: builder.mutation<
      void,
      { firstName: string; lastName: string; phone: string }
    >({
      query: (data) => ({
        url: "/profile",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [TagType.UserProfile],
    }),
    changePassword: builder.mutation<
      void,
      { oldPassword: string; newPassword: string }
    >({
      query: (data) => ({
        url: "/change-password",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetUserInfoQuery,
  useGetAddressesQuery,
  useAddAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  useSetDefaultAddressMutation,
  useUpdateProfileMutation,
  useChangePasswordMutation,
} = userApi;
